export const SET_DEFAULT_LAYOUT = 'PROJECT_EDIT/SET_DEFAULT_LAYOUT'
export const UPDATE_PROJECT = 'PROJECT_EDIT/UPDATE_PROJECT'
export const SET_PROJECT_ID = 'PROJECT_EDIT/SET_PROJECT_ID'
export const CLEAR_PROJECT = 'PROJECT_EDIT/CLEAR_PROJECT'
